<template>
  <div>
    <div v-if="show" class="toast-wrapper" @click="show = false">
      <div class="toast" :class="'toast--' + toastType">
        <span class="toast__icon-circle" :class="'toast__icon-circle--' + toastType">
          {{ toastEmoji }}
        </span>
        <span class="toast__text">{{ text }}</span>
        <span class="toast__close">&times;</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    show: false,
    text: '',
    type: 'success',
    hideTimer: null,
  }),
  computed: {
    toastType() {
      const color = (this.type || 'success').toLowerCase();
      if (color.includes('error') || color.includes('red')) return 'error';
      if (color.includes('info') || color.includes('blue')) return 'info';
      if (color.includes('warning') || color.includes('orange')) return 'warning';
      return 'success';
    },
    toastEmoji() {
      switch (this.toastType) {
        case 'error': return '!';
        case 'info': return 'i';
        case 'warning': return '!';
        default: return '\u2713';
      }
    },
  },
  created() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === "updateSnackbar") {
        const payload = mutation.payload || {};
        if (payload.text) {
          this.text = payload.text;
          this.type = payload.color || 'success';

          this.show = false;
          clearTimeout(this.hideTimer);

          const self = this;
          setTimeout(function() {
            self.show = true;
            self.hideTimer = setTimeout(function() {
              self.show = false;
            }, payload.timeout && payload.timeout >= 1500 ? payload.timeout : 2500);
          }, 50);
        }
      }
    });
  },
  beforeDestroy() {
    clearTimeout(this.hideTimer);
  },
};
</script>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .toast {
  background: var(--app-card);
  border: 1px solid var(--app-border);
}

.dark-mode .toast__icon-circle--success {
  background: var(--app-success-bg);
}

.dark-mode .toast__icon-circle--error {
  background: var(--app-danger-bg);
}

.dark-mode .toast__icon-circle--warning {
  background: var(--app-warning-bg);
}

.dark-mode .toast__text {
  color: var(--app-text);
}

.dark-mode .toast__close {
  color: var(--app-text-faint);
}

.dark-mode .toast__close:hover {
  color: var(--app-text-muted);
}

/* >>> end auto-dark <<< */

/* Wrapper - top right fixed */
.toast-wrapper {
  position: fixed !important;
  top: 20px !important;
  right: 20px !important;
  z-index: 999999 !important;
  cursor: pointer;
  animation: toastSlideIn 0.3s ease;
}

/* Toast card */
.toast {
  display: flex !important;
  align-items: center !important;
  gap: 12px;
  padding: 14px 18px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  border: 1px solid #e8eaed;
  min-width: 260px;
  max-width: 420px;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Left accent */
.toast--success { border-left: 4px solid #10b981; }
.toast--error { border-left: 4px solid #ef4444; }
.toast--info { border-left: 4px solid #0ea5e9; }
.toast--warning { border-left: 4px solid #f59e0b; }

/* Icon circle */
.toast__icon-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
}

.toast__icon-circle--success { background: #f0fdf4; color: #10b981; }
.toast__icon-circle--error { background: #fef2f2; color: #ef4444; }
.toast__icon-circle--info { background: #f0f7ff; color: #0ea5e9; }
.toast__icon-circle--warning { background: #fffbeb; color: #f59e0b; }

/* Text */
.toast__text {
  flex: 1;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.4;
}

/* Close */
.toast__close {
  font-size: 18px;
  color: #94a3b8;
  line-height: 1;
  flex-shrink: 0;
  padding: 0 2px;
}

.toast__close:hover {
  color: #64748b;
}

/* Animation */
@keyframes toastSlideIn {
  from {
    opacity: 0;
    transform: translateX(40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Dark mode */
.dark-mode .toast {
  background: var(--app-page);
  border-color: var(--app-border);
}

.dark-mode .toast__text {
  color: var(--app-text);
}

.dark-mode .toast__icon-circle--success { background: var(--app-success-bg); }
.dark-mode .toast__icon-circle--error { background: var(--app-danger-bg); }
.dark-mode .toast__icon-circle--info { background: var(--app-accent-soft); }
.dark-mode .toast__icon-circle--warning { background: var(--app-warning-bg); }
</style>
